import { Button } from '../catalyst/button'
import { Link } from '../catalyst/link'
import { useAuth } from '../lib/auth'
import { useLogDrafts } from './use-log-drafts'

/** The way into the logging wizard, with a count of entries started but not finished. */
export function LogButton({ farmId, fieldId }: { farmId: string; fieldId?: string }) {
  const { org } = useAuth()
  const { drafts } = useLogDrafts(org?.id, [farmId])
  return (
    <span className="inline-flex items-center gap-2">
      <Button href={`/farms/${farmId}/log${fieldId ? `?field=${fieldId}` : ''}`}>Log what you did</Button>
      {drafts.length > 0 && (
        <Link href={`/farms/${farmId}/log`} className="text-sm/6 font-medium text-emerald-700 dark:text-emerald-400">
          {drafts.length} unfinished
        </Link>
      )}
    </span>
  )
}
